export default {
  reservations: 'Reservationer',
  activated: 'Aktiveret',
  deactivated: 'Deaktiveret',
  reservations_deactivated: 'Reservationer er deaktiveret.',
  tabs: {
    general: 'Generelt',
    information: 'Information',
  },
  sections: {
    notifications_confirmation: 'Notifikationer og bekræftelse',
    notifications_confirmation_description: 'Hvordan gæster booker, og hvordan du får besked.',
    who_can_book: 'Hvem kan booke',
    who_can_book_description: 'Grænser for selskabsstørrelse ved onlinereservationer.',
    when_how_bookings_work: 'Hvornår og hvordan bookinger fungerer',
    when_how_bookings_work_description:
      'Regler for timing, varighed og kapacitet, der afgør, hvilke tidspunkter gæster kan se.',
  },
  google: {
    label: 'Vis reservationer på Google',
  },
  storefront: {
    label: 'Vis reservationer på webshoppen',
  },
  auto_confirm: {
    label: 'Bekræft reservationer automatisk',
  },
  email: {
    label: 'E-mail til indkommende reservationer',
    add: 'Tilføj e-mail',
    placeholder: 'Indtast e-mail',
    required: 'Tilføj mindst én e-mail for at modtage nye reservationer.',
    invalid: 'Indtast en gyldig e-mailadresse.',
  },
  has_whatsapp_phone_number: {
    label: 'Send notifikationer via WhatsApp',
  },
  whatsapp_phone_number: {
    label: 'WhatsApp-nummer',
    add: 'Tilføj telefonnummer',
  },
  party_size: {
    label: 'Tilladt selskabsstørrelse pr. reservation',
    min_label: 'Min.',
    max_label: 'Maks.',
    to: 'til',
    guests: 'gæster',
    helper:
      'Hvor lille eller stor en booking kan være. En gæst kan kun reservere til et antal personer inden for dette interval.',
    warning:
      'Google accepterer kun bookinger for 2–16 gæster. Bookinger uden for dette interval fungerer stadig på din webshop, men vises ikke på Google.',
    warning_min: 'Google anbefaler et minimum på 2 gæster pr. reservation.',
    warning_max: 'Google anbefaler et maksimum på 16 gæster pr. reservation.',
    min_note: 'Google tilbyder ikke reservationer til selskaber på under {{count}}.',
  },
  time_slot: {
    label: 'Bookinginterval',
    helper: 'Gæster kan booke i intervaller af dette antal minutter.',
    extra: 'f.eks. {{example}}',
  },
  reservation_gap: {
    label: 'Bookingstop før lukketid',
    helper: 'Det seneste tidspunkt, en gæst kan starte en booking, regnet baglæns fra din lukketid.',
    helper_link: 'Se dine reservationstider',
    extra: 'f.eks. du lukker kl. 22:00, stop {{example}} min → seneste bookbare starttidspunkt er {{example}}',
  },
  reservation_notice_period: {
    label: 'Minimum varsel',
    helper: 'Det tidligste tidspunkt, en gæst kan booke inden ankomst.',
    extra: 'f.eks. book senest {{example}} til ankomst kl. 18:00',
  },
  opening_times: {
    label: 'Åbningstider',
  },
  total_seats: {
    label: 'Samlet gæstekapacitet',
    helper:
      'Det maksimale antal gæster (ikke borde), der kan sidde samtidig. Tæl individuelle siddepladser – f.eks. 5 borde à 4 = 20.',
  },
  capacity_explainer: {
    title: 'Sådan fungerer kapacitet',
    body: 'Dette er, hvor mange gæster du kan placere ad gangen. Hver booking holder sine pladser i sin varighed og frigiver dem derefter til de næste gæster. Systemet holder plads til alle bookede, så du aldrig bliver overbooket.',
    body_example:
      'Eksempel: med 20 siddepladser kan du tage imod en booking på 12 gæster kl. 19:00 og en på 10 gæster kl. 21:00, fordi det første selskabs pladser frigives, før det næste ankommer.',
  },
  note: {
    label: 'Bemærkning',
  },
  grace_period: {
    label: 'Venteperiode',
    helper: 'Hvor længe et bord holdes efter reservationens starttidspunkt.',
    tooltip:
      'Ekstra buffer, der lægges til efter en bookings varighed, før bordet tilbydes igen (f.eks. til at rydde og gøre bordet klar).',
    extra: 'f.eks. holdes til {{example}} ved en booking kl. 18:00',
    placeholder: 'Indtast venteperiode',
  },
  information: {
    rules: {
      label: 'Dit bord er reserveret i:',
      add: 'Tilføj',
    },
  },
  reservation_duration: {
    label: 'Reservationsvarighed',
    helper: 'Hvor længe hvert bord holdes pr. booking.',
    tooltip:
      'Hvor længe et bord holdes til hver booking. Bruges til at beregne, hvornår et bord bliver ledigt igen til de næste gæster.',
    extra: 'f.eks. 18:00 – {{example}}',
    minutes: '{{ count }} minutter',
    hour_one: '{{ count }} time',
    hour_other: '{{ count }} timer',
  },
  buttons: {
    save: 'Gem',
    activate: 'Aktiver',
    deactivate: 'Deaktiver',
  },
  success_messages: {
    updated: 'Opdatering gennemført',
    saving_successful: 'Opdatering gennemført. Bemærk, at det kan tage op til 24 timer, før Google viser ændringerne.',
  },
  error_messages: {
    invalid_phone_number: 'Ugyldigt telefonnummer',
    saving_unsuccessful: 'Fejl ved lagring af ændringer. Prøv igen.',
    enter_correct_email: 'Indtast en gyldig e-mailadresse.',
  },
};
